import React from 'react'

export function NoSubmissions() {
  return (
    <div className="d-flex">
      <h2 className="mx-auto">No Submissions Found</h2>
    </div>
  )
}
